import { messages as ptBr } from './messages'

export type MessageKey =
  | 'beforeEqual130Years'
  | 'beforeEqualToday'
  | 'celularInvalid'
  | 'cnpjInvalid'
  | 'cpfInvalid'
  | 'emailInvalid'
  | 'empty'
  | 'invalid'
  | 'length'
  | 'match'
  | 'maxLength'
  | 'maxRange'
  | 'minLength'
  | 'minRange'
  | 'NaN'
  | 'nome'
  | 'nomeInvalido'
  | 'nomeOneLetter'
  | 'nomeTwoLetters'
  | 'numericRange'
  | 'pisInvalid'
  | 'range'
  | 'required'
  | 'requiredDomain'
  | 'senha'
  | 'documentacaoRequired'
  | 'senhaSpecialChars'
  | 'telefoneInvalid'
  | 'tituloEleitorInvalid'

export type ValidationMessages = { [key in MessageKey]: (value: any, ...args: any[]) => string }

export const msg = (key: MessageKey, value?: any, ...args: any[]): string => ptBr[key](value, ...args)
